<template>
  <div>
    <div class="tableInfo">
      <div class="flex_space">
        <span class="titel">
          セントラルフィールド中目黒 下水道の点検工事［20220805-A123］
        </span>
        <span class=""></span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {}
</script>

<style scoped></style>
